import { TX } from '../registry/keys';

/** House upgrade tiers — renovate over time from a cottage up to a castle. */
export interface HouseTier {
  name: string;
  texture: string;
  /** Sprite height in px (rendered bottom-anchored so grander tiers tower upward). */
  texH: number;
  cost: { gold: number; items?: { itemId: string; qty: number }[] };
}

export const HOUSE_TIERS: HouseTier[] = [
  { name: 'Cottage', texture: TX.house, texH: 40, cost: { gold: 0 } },
  { name: 'Cabin', texture: TX.cabin, texH: 42, cost: { gold: 600, items: [{ itemId: 'wood', qty: 10 }] } },
  { name: 'Farmhouse', texture: TX.house2, texH: 46, cost: { gold: 1500, items: [{ itemId: 'wood', qty: 20 }] } },
  { name: 'Manor', texture: TX.house3, texH: 54, cost: { gold: 4000, items: [{ itemId: 'stone', qty: 25 }] } },
  { name: 'Estate', texture: TX.estate, texH: 58, cost: { gold: 9000, items: [{ itemId: 'stone', qty: 40 }, { itemId: 'iron_bar', qty: 10 }] } },
  { name: 'Castle', texture: TX.castle, texH: 64, cost: { gold: 18000, items: [{ itemId: 'stone', qty: 60 }, { itemId: 'gem', qty: 8 }] } },
];
